import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { autoPlay } from "react-swipeable-views-utils";
export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            margin: '12px 8px',
            flexDirection: 'column',
            
            justifyContent: 'center',
            alignItems: 'center',
        },
        img: {
            width: 101.07,
            height: 127.73,
            marginBottom: 8,
        },
        heading: {
            position: 'static',
            fontSize: 14,
            fontWeight: 700,
        },
        description: {
            fontSize: 14,
            marginLeft: 36,
            marginRight: 35,
            marginTop: 8,
            maxLines: 2,
            textAlign: 'center',
        },
        button: {
            textTransform: 'capitalize',
            backgroundColor: '#0E4BB4',
            color: '#0E4BB4',
            padding: 10,
            fontSize: 13,
            opacity: 0.8,
            width: 170,
            height: 48,
            marginLeft: 9,
            fontWeight: 500,
            marginTop: 16,
            marginBottom: 16,
        },
    }),
);